import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.less";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { routers } from "./router";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { message } from "antd";
import { HelmetProvider } from "react-helmet-async";

message.config({ maxCount: 1 });

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <Suspense fallback={<>loading...</>}>
          <RouterProvider router={routers} />
        </Suspense>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
